import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileImport } from '@fortawesome/free-solid-svg-icons'
import { Loader } from '../../helpers/loader';
import { supabase } from '../../api'

import { DISH_PID_ADD, formatDate, formatDateYMD, RECIPE_PID_ADD, wait } from '../../helpers/utils';

var Strings = {
    /**
     * Wrapped CSV line parser
     * @param s      String delimited CSV string
     * @param sep    Separator override
     * @attribution: http://www.greywyvern.com/?post=258 (comments closed on blog :( )
     */
    parseCSV : function(s,sep) {
        // http://stackoverflow.com/questions/1155678/javascript-string-newline-character
        var universalNewline = /\r\n|\r|\n/g;
        var a = s.split(universalNewline);
        for(var i in a){
            if (typeof a[i] !== 'function') {
            for (var f = a[i].split(sep = sep || ","), x = f.length - 1, tl; x >= 0; x--) {
                if (f[x].replace(/"\s+$/, '"').charAt(f[x].length - 1) === '"') {
                    if ((tl = f[x].replace(/^\s+"/, '"')).length > 1 && tl.charAt(0) === '"') {
                        f[x] = f[x].replace(/^\s*"|"\s*$/g, '').replace(/""/g, '"');
                      } else if (x) {
                    f.splice(x - 1, 2, [f[x - 1], f[x]].join(sep));
                  } else f = f.shift().split(sep).concat(f);
                } else f[x].replace(/""/g, '"');
              } a[i] = f;
            }
    }
    return a;
    }
}

export const RecipeImporter = () => {

    const [data, setData] = useState([])

    const [recipes, setRecipes] = useState()

    const [recipeData, setRecipeData] = useState()


    const [loading, setLoading] = useState(false)

    const [done, setDone] = useState(false)
    let activeRecipes = []
    
    const DO_SAVE_RECIPES = true
    const DO_SAVE_INGREDIENTS = true
    const DO_SAVE_STEPS = true

    const IMPORTED_AT = (new Date()).toISOString()


    const getPID = (type,pid) => {
        let newPID = parseInt(pid)
        if (type === 'DISH' || type === 'D') newPID = parseInt(pid)+DISH_PID_ADD
        if (type === 'RECIPE' || type === 'R') newPID = parseInt(pid)+RECIPE_PID_ADD
        return newPID
    }

    const handleFile = async (e) => {
        const content = e.target.result;
        const csv = Strings.parseCSV(content)

        const { data: recipes, error: recipesErr } = await supabase
            .from('recipes')
            .select()
        
        setRecipes(recipes)

        setData(csv)

        const processedRecipeData = await processRecipes(csv)
        
        await saveRecipes(processedRecipeData, recipes)
        setRecipeData(processedRecipeData)

        setLoading(false)
        setDone(true)
    }
      
    const handleChangeFile = async (file) => {

        setLoading(true)

        
            
        const { data, error } = await supabase
        .storage
        .from('imports')
        .upload(`/recipes/${formatDateYMD(new Date())}/${file.name}`, file, {
            cacheControl: '3600',
            upsert: true
        })
        
        if (error) console.error(error)
        console.log('file uploaded', data)

        
        
        let fileData = new FileReader();
        fileData.onloadend = handleFile;
        fileData.readAsText(file, 'ISO-8859-1');
    }

    if (loading) return (
        <div className='import-wrapper'><Loader /></div>
    )

    const toBool = (val) => {
        if (val === 'Y' || val === '"Y"') return true
        return false
    }

    const clean = (val) => {
        if (val[0]==='"' && val[val.length-1]==='"') val = val.slice(1, -1)
        else if (val[0]==='"') val = val.slice(1)
        return val
    }

    const saveRecipes = async (recipeData, recipes) => {

        console.log('******************************************')
        console.log('******************************************')
        console.log('************  SAVING RECIPES  ************')
        console.log('******************************************')
        console.log('******************************************')
        console.log('****  RECIPE RECORDS WILL BE UPDATED  ****')
        console.log('*  INGREDIENT RECORDS WILL BE REPLACED  **')
        console.log('*****  METHOD STEPS WILL BE REPLACED  ****')
        console.log('******************************************')
        console.log('******************************************')
        
        console.log('recipes.length', recipes.length)
        let createdIngredients = []

        let dup = []
        let updated = 0
        let inserted = 0

        const keys = Object.keys(recipeData)

        const recipeRecords = []

        for (let index = 0; index < keys.length; index++) {

            const recipe = recipeData[keys[index]]
        

            if (recipe.isActive) {

                const suitables = Object.entries(recipe.suitables).filter(a=>!!a[1]).map(a => a[0])
                const recipeRecord = {
                    type: recipe.type,
                    pid: recipe.pid,
                    name: recipe.title,
                    desc: recipe.title === recipe.desc ? '' : recipe.desc, 
                    terms: recipe.terms,
                    quantity: recipe.numToServe ? parseFloat(recipe.numToServe) : undefined,
                    quantity_unit: recipe.serveMeasurement,
                    suitables: suitables.length ? suitables.join(',') : undefined,
                    imported_at: IMPORTED_AT
                }

                const oldRecipe = recipes.find(r => r.pid === recipeRecord.pid)
                if (oldRecipe) {
                    // keep allergens and display name and label_name
                    recipeRecord.allergens = oldRecipe.allergens
                    recipeRecord.no_allergens = oldRecipe.no_allergens
                    recipeRecord.display_name = oldRecipe.display_name
                    recipeRecord.label_name = oldRecipe.label_name
                }

                recipeRecords.push(recipeRecord)
   
            }
        }


        if (DO_SAVE_RECIPES) {
            console.warn('UPSERTING RECIPES')

            const batchSize = 3000;
            for (let i = 0; i < recipeRecords.length; i += batchSize) {
                const batch = recipeRecords.slice(i, i + batchSize);
                console.log(i, '->', i+batchSize, '...')
                const { error } = await supabase.from('recipes').upsert(batch);
                if (error) {
                    console.error("error upserting new recipes:", error);
                    break;
                }
            }
            
        }
        else {
            console.warn('WOULD UPSERT RECIPES: ', recipeRecords)
            
        }
        activeRecipes = recipeRecords


        let stepsToInsert = []

        // process methods

        window.activeRecipes = activeRecipes

        for (let index = 0; index < keys.length; index++) {

            const recipe = recipeData[keys[index]]

            const activeRecipe = activeRecipes.find(r => r.pid === recipe.pid)

            
            
            //insert steps
            if (recipe.isActive) {

                if (activeRecipe) {

                    if (recipe.method && recipe.method.length) {
                        const steps = recipe.method.map((m,i) => (
                            {
                                recipe_pid: activeRecipe.pid,
                                txt: m,
                                pos: i+1,
                            }
                        ))

                        stepsToInsert.push(steps)

                        /*if (DO_SAVE) {
                            const { data: deleteSteps, error: deleteStepsErr } = await supabase
                            .from('steps')
                            .delete()
                            .match({ recipe_pid: activeRecipe.pid })

                            //console.log(deleteSteps)
                            if (deleteStepsErr) console.error(deleteStepsErr)

                            console.log('steps', steps)
                            const { data: insertedSteps, error: insertedStepsErr } = await supabase
                                .from('steps')
                                .insert(steps)

                            //console.log(insertedSteps)
                            if (insertedStepsErr) console.error(insertedStepsErr)
                            if (insertedSteps) console.log(steps.length, 'steps created for ', recipe.pid)
                        }
                        else {
                            console.log('WOULD CREATE STEPS', steps)
                        }*/
                    }
                
                }

                if (recipe.ingredients && recipe.ingredients.length) {
                    for (let i = 0; i < recipe.ingredients.length; i++) {
                        const ing = recipe.ingredients[i]
    
                        const pid = getPID(ing[2], ing[3])
    
                        const activeRecipe = activeRecipes.find(r => r.pid === pid)

                        if (!activeRecipe) {
                            
                            
                            const recipeRecord = {
                                type: 'P',
                                pid: pid,
                                name: ing[4],
                                size: ing[5], 
                                imported_at: IMPORTED_AT
                            }
    
                            const foundAlready = createdIngredients.find(c=>c.pid===pid)

                            if (foundAlready) {
                                dup.push(recipeRecord)
                                //console.log('ingredient found already: ', ing[4])
                            }
                            else {
                                createdIngredients.push(recipeRecord)
                                //console.log('ingredient needs creating: ', ing[4])
                            }
    
                            
                        }
                        else {
                            // found already
                        }
                        
    
                    }
                }

            }

            // create new recipe records for ingredients

            console.log('---------------')
        }

        stepsToInsert = stepsToInsert.flat()

        console.log('stepsToInsert', stepsToInsert)

        if (DO_SAVE_STEPS) {

            //delete all steps
            console.warn('DELETING OLD STEPS')
            const { data: deleteSteps, error: deleteStepsErr } = await supabase
            .from('steps')
            .delete()
            .neq('pos', 0)
            
            if (deleteStepsErr) console.error(deleteStepsErr)

            console.warn('CREATING NEW STEPS: ', stepsToInsert.length)
            const { data: insertedSteps, error: insertedStepsErr } = await supabase
                .from('steps')
                .insert(stepsToInsert)

            if (insertedStepsErr) console.error(insertedStepsErr)

        }
        else {
            console.warn('WOULD CREATE STEPS', stepsToInsert.length)
        }


        if (DO_SAVE_RECIPES) {
            console.warn('UPSERTING NEW RECIPES: ', createdIngredients.length)
            const { data: newRecipes, error: newRecipesError } = await supabase
            .from('recipes')
            .upsert(createdIngredients)
            .select()
            if (newRecipesError) {
                console.error('error inserting new recipes', newRecipesError)
            }
            if (newRecipes) {
                activeRecipes = [...activeRecipes, ...newRecipes]
            }

        }
        else {
            console.warn('WOULD UPSERT RECIPES FOR INGREDIENTS', createdIngredients.length)
            activeRecipes = [...activeRecipes, ...createdIngredients]
        }
        // process ingredient records


        const ingredientRecords = []
        for (let index = 0; index < keys.length; index++) {

            const recipe = recipeData[keys[index]]

            
            const parentRecipe = activeRecipes.find(r => r.pid === recipe.pid) || recipes.find(r => r.pid === recipe.pid)

            

            // only process active Recipes
            if (parentRecipe) {
                if (recipe.isActive && recipe.ingredients && recipe.ingredients.length) {
                    for (let i = 0; i < recipe.ingredients.length; i++) {
                        const ing = recipe.ingredients[i]

                        const pid = getPID(ing[2], ing[3])

                        
                        const childRecipe = activeRecipes.find(r => r.pid === pid) || recipes.find(r => r.pid === pid)

                        if (childRecipe) {
                            const iRecord = {
                                parent_pid: parentRecipe.pid,
                                child_pid: childRecipe.pid,
                                quantity: parseFloat(ing[6]),
                                quantity_unit: ing[7],
                                position: parseInt(ing[9]) || 0
                            }

                            ingredientRecords.push(iRecord)
                            
                        }
                        else {
                            console.error('??? >>> recipe record not found for >>>', ing)
                        }
                    }

                }
            }
        }

        // CLEAN INGREDIENT DUPLICATES........

        const irs = []
        const cleanedIngredients = []
        ingredientRecords.forEach(i => {
            const ref = `${i.parent_pid}:${i.child_pid}:${i.position}`
            if (irs.includes(ref)) {
                console.log('DUPLICATE: ', i)
            }
            else {
                irs.push(ref)
                cleanedIngredients.push(i)
            }
        })
    
        if (DO_SAVE_INGREDIENTS) {

            // delete ALL ingredients
            console.warn('DELETING ALL INGREDIENT RELATIONS')
            const { data: deleteIng, error: deleteIngErr } = await supabase
                .from('ingredients')
                .delete()
                .neq('parent_pid', 0)

            // insert new
            console.warn('INSERTING NEW INGREDIENT RELATIONS')
            const { data: newIngredients, error: newIngredientsError } = await supabase
                .from('ingredients')
                .insert(cleanedIngredients)
                .select()
                if (newIngredientsError) {
                    console.error('error inserting new ingredients', newIngredientsError)
                }
                if (newIngredients) {
                    //console.log(newIngredients.length, ' new ingredients created', newIngredients)
                }

        }
        else {
            console.warn('WOULD INSERT NEW INGREDIENTS', cleanedIngredients.length)
        }



        console.log('.')
        console.log('.')
        console.log('.')
        console.log('.')
        console.log('DONE')
        

    }

    const processRecipes = async (data) => {

        const dataSet = {}
        const cleanData = []

        //clean data - for DESCRIPTIONS with carriage returns in
        data.forEach(row => {
            if (row.length < 4) {
                if (row[0].length) {
                    const txt = row.join('')
                    const lastRow = cleanData[cleanData.length-1]
                    lastRow[3]+=' ' + txt
                }
                return
            }
            cleanData.push(row)
        })  


        let lastId = -1
        let pid = 'X'

        cleanData.map((row,i) => {

            if (parseInt(row[0]) !== lastId) {
                lastId = parseInt(row[0]) 
                pid = getPID(row[1], row[0])
            }

            const group = row[1]
            const field = row[2]
            const val = clean(row[3])

            if (!dataSet[pid]) dataSet[pid] = { 
                pid: pid,
                allergens: {},
                suitables: {},
                method: [],
                ingredients: [],
            }

            if (group === 'RECIPE') {
                dataSet[pid].type = 'R'
                if (field === 'TITLE [E]') dataSet[pid].title = val
                if (field === 'DESCRIPTION [E]') dataSet[pid].desc = val

                if (field === 'SEARCH TERMS [E]') dataSet[pid].terms = val
                if (field === 'AUTHOR [E]') dataSet[pid].author = val
                if (field === 'NUMBER TO SERVE [E]') dataSet[pid].numToServe = val
                if (field === 'SERVE MEASUREMENT [E]') dataSet[pid].serveMeasurement = val

                if (field === 'IS PUBLIC [E]') dataSet[pid].isPublic = toBool(val)
                if (field === 'IS ACTIVE [E]') dataSet[pid].isActive = toBool(val)
                if (field === 'SHARE WITH ALL USERS [E]') dataSet[pid].shareAll = toBool(val)
            }
            else if (group === 'DISH') {
                dataSet[pid].type = 'D'
                if (field === 'TITLE [E]') dataSet[pid].title = val
                
                if (field === 'SEARCH TERMS [E]') dataSet[pid].terms = val
                if (field === 'AUTHOR [E]') dataSet[pid].author = val
                if (field === 'WASTAGE [E]') dataSet[pid].wastage = val
                if (field === 'STAFF FEEDING [E]') dataSet[pid].staffFeeding = val

                if (field === 'SEASONAL VARIATION [E]') dataSet[pid].seasonalVariation = val
                if (field === 'IS ACTIVE [E]') dataSet[pid].isActive = toBool(val)
                if (field === 'SHARE WITH ALL USERS [E]') dataSet[pid].shareAll = toBool(val)
            }
            else if (group === 'ALLERG') {
                if (field.includes('SUITABLE')) {
                    if (toBool(val)) dataSet[pid].suitables[field.split('SUITABLE').join('')] = toBool(val)
                }
                else if (toBool(val)) dataSet[pid].allergens[field] = toBool(val)
            }
            else if (group === 'METHOD') {

                const cleaned = val.replace(/^((step)*\s*([0-9]+)\.*\s*\-*\s*)(.*)/gis, "$3|$4");
                
                dataSet[pid].method.push(cleaned)
            }
            else if (group === 'ITEMHD') {
                // ?
            }
            else if (group === 'INGRED') {
                dataSet[pid].ingredients.push(row)
            }

        })

        window.dataSet = dataSet

        return dataSet

    }




    if (recipeData) {

        return (
            <div className='import-wrapper'>
                <br/>
                <h1>{done && 'UPLOAD COMPLETE'}</h1>
                <br/>
            </div>
        )
    }

    return (
        <div className='import-wrapper'>
            <div className='file-upload-wrapper'>
            <label tabIndex={0} className='file-upload-button' htmlFor='recipe-upload'><FontAwesomeIcon icon={faFileImport} />&nbsp;&nbsp;Import PW Recipes</label>
            <input id='recipe-upload' type="file" accept=".csv" onChange={e => handleChangeFile(e.target.files[0])} /> 
            </div>
            
        </div>
    )
    
}

export default RecipeImporter;
